/**
 * @generated SignedSource<<dc5f4d5ca48cc92f49b06bf848f80444>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Locale = "EN" | "LT";
import { FragmentRefs } from "relay-runtime";
export type TranslatableTextField_data$data = {
  readonly languages: ReadonlyArray<{
    readonly locale: Locale;
    readonly " $fragmentSpreads": FragmentRefs<"TranslatableTextFieldInput_language">;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"TranslatableTextFieldInput_data">;
  readonly " $fragmentType": "TranslatableTextField_data";
};
export type TranslatableTextField_data$key = {
  readonly " $data"?: TranslatableTextField_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"TranslatableTextField_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TranslatableTextField_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Language",
      "kind": "LinkedField",
      "name": "languages",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "locale",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TranslatableTextFieldInput_language"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TranslatableTextFieldInput_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "828572243e661483d8d91119535d8e3e";

export default node;
